/* tslint:disable */

/**
 */
export class Login {
    username?: string;
    password?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/login.ts